import { APP_DOMAIN } from 'modules/app/constants'
import { ROUTER_DOMAIN } from 'modules/router/constants'
import { CATEGORIES_DOMAIN } from 'modules/categories/constants'
import { CIDS_DOMAIN } from 'modules/training/modules/cids'
import { REFERENCES_DOMAIN } from 'modules/training/modules/references/constants'
import { VIEWPORT_DOMAIN } from 'modules/viewport/constants'
import { ARTICLES_DOMAIN } from 'modules/articles/constants'
import { PAGES_DOMAIN } from 'modules/pages/constants'
import { MOTIVATION_DOMAIN } from 'modules/motivation/constants'
import { TAGS_DOMAIN } from 'modules/tags/constants'
import { SECTIONS_DOMAIN } from 'modules/sections/constants/index.cjs'

const REDUX_PUBLIC_DOMAINS = [
  APP_DOMAIN,
  ROUTER_DOMAIN,
  CATEGORIES_DOMAIN,
  CIDS_DOMAIN,
  REFERENCES_DOMAIN,
  VIEWPORT_DOMAIN,
  ARTICLES_DOMAIN,
  PAGES_DOMAIN,
  MOTIVATION_DOMAIN,
  TAGS_DOMAIN,
  SECTIONS_DOMAIN
]

export {
  REDUX_PUBLIC_DOMAINS
}
